import { CognitoUser } from '@aws-amplify/auth';
import { createContext } from 'react';

export const AppContext = createContext<{
  loginInfo?: CognitoUser;
  generalErrors?: string[];
  setLoginInfo?: (x: CognitoUser) => void;
  setGeneralErrors?: (x: any) => void;
}>({});
